<template>
  <div class="current-rides container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>

    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">{{ title }}</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }}</li>
            </ol>
        </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form class="form-material">
              <div class="row">
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">SMS Sent</label>
                    <select type="text" placeholder="SMS Sent" class="form-control ddown" v-model="selected_time_range">
                      <option v-bind:value="'All'" >All</option>
                      <option v-bind:value="24" >Last 24 hours</option>
                      <option v-bind:value="48" >Last 48 hours</option>
                      <option v-bind:value="168" >Last Week</option>
                    </select>
                  </div>
                </div>                
                <div class="col-md-5 col-lg-5 p-0">
                  <div class="m-3">
                    <label class="search-label">Select Ride Statuses</label>
                    <multiselect
                      v-model="current_ride_status"
                      :multiple="true"
                      :close-on-select="true"
                      :show-labels="false"
                      :searchable="false"
                      label="name"
                      track-by="value"
                      placeholder="All"
                      :options="data.filters.status">
                    </multiselect>
                                        
                  </div>


                </div>

                <!--  -->

         
                <div class="col-3 m-3 p-0 submit-button">
                  <a @click="currentButtonSearch()" style="color: white" class="btn btn-info waves-effect waves-light m-t-10" > Search </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="result">
              <div class="table-responsive">
                <table class="table table-hover table-sm">
                  <thead>
                    <tr>
                      <th style="width: 100px">
                        Page Size
                      </th>
                      <th>
                        <select v-model="perPage" class="form-control table-select" @change="checkPageSize($event)">
                          <option v-for="size in page_sizes">
                            {{size}}
                          </option>
                        </select>
                      </th>
                    </tr>
                    <br>
                    <tr>
                      <th class="result-label" v-for="(column) in data.resultColumns" v-on:click="sortResults($event)">
                        <div class="nowrap" style="">
                          {{column}}
                          <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="col-12">
                  <tr v-for="willcall in data.sortedRides" :set="ride = willcall.ride ">
                    <td class="result-item nowrap">
                      <router-link :to="'/rides/' + ride.id_ride + '/'">
                        <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                        {{ ride.id_alternate }}
                      </router-link>
                    </td>
                    <td class="result-item nowrap" >
                      <router-link :to="'/search-rides/?id_group_ride=' + ride.id_group_ride" v-if="ride.id_group_ride" style="padding: 0.3rem;" target="_blank">
                        {{ ride.id_group_ride }}
                      </router-link>

                      <component v-if="!ride.id_group_ride">{{ 'N/A' }}</component>
                    </td>
                    <td class="result-item nowrap">
                      {{ ride.id_type_ride_status && ride.id_type_ride_status.name ? ride.id_type_ride_status.name : 'N/A' }}</td>
                    <td class="result-item nowrap">
                      <router-link v-if="ride.id_driver" :to="'/drivers/' + ride.id_driver.id_user + '/'">
                        {{ ride.id_driver.name_first + ' ' + ride.id_driver.name_last }}
                        <br>
                      </router-link>
                      <!--<span v-if="ride.id_driver" class="">{{ ride.id_driver.email }}</span>-->
                    </td>

                    <td class="result-item nowrap">
                      <router-link v-if="ride.id_rider" :to="'/users/' + ride.id_rider.id_user + '/'">
                        {{ (ride.contact_first_name ? ride.contact_first_name : ride.id_rider.name_first) + " " + (ride.contact_last_name ? ride.contact_last_name : ride.id_rider.name_last) }}
                        <br>
                      </router-link>
                      <!--<span v-if="ride.id_rider" class="">{{ ride.id_rider.email }}</span>-->
                    </td>
                    <td class="result-item nowrap">
                      <span 
                            :class="[(data.waiting_statuses.includes(ride.id_type_ride_status.code) && moment.utc(willcall.created_at).diff(moment.utc(), 'hours') < -24) ? 'text-danger' : '']" 
                            :title="!willcall.created_at ? 'N/A' : ride.local_timezone ? moment.utc(willcall.created_at).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(willcall.created_at).format('MMMM Do YYYY, h:mm:ss a (z)')">
                          {{ !willcall.created_at ? '' : moment.utc(willcall.created_at).fromNow() }}
                      </span>
                    </td>
                    <td class="result-item nowrap">
                      <span :class="[(data.waiting_statuses.includes(ride.id_type_ride_status.code) && moment.utc(willcall.confirmed_at).diff(moment.utc(), 'hours') < -1) ? 'text-danger' : '']"
                            :title="!willcall.confirmed_at ? 'N/A' : ride.local_timezone ? moment.utc(willcall.confirmed_at).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(willcall.confirmed_at).format('MMMM Do YYYY, h:mm:ss a (z)')">
                        {{ !willcall.confirmed_at ? '' : moment.utc(willcall.confirmed_at).fromNow() }}
                      </span>
                    </td>
                    <!-- <td class="result-item" v-bind:style="ride.info.includes('late') ? 'color:red' : ride.info.includes('left') ? 'color:green' : ride.info.includes('Expire') ? 'color:orange' : ride.info.includes('Departure') ? 'color:red' : 'color: black'">
                      <span class="">{{ ride.info }}</span>
                    </td> -->
                    <td class="result-item">
                      <span class="">{{ ride.default_pickup_address }}</span>
                    </td>
                    <td class="result-item">
                      <span class="">{{ ride.default_dropoff_address }}</span>
                    </td>
<!--                    <td class="result-item">-->
<!--                      <span v-if="ride.id_business_provider != null">{{ ride.id_business_provider.name_first + " " + ride.id_business_provider.name_last }}</span>-->
<!--                    </td>-->
                  </tr>
                  </tbody>
                </table>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="totalRows > 0">Showing {{ perPage * (currentPage-1) + 1 }} to {{ perPage * currentPage > totalRows ? totalRows : perPage * currentPage }} of {{ totalRows }} entries</span>
                    <span v-else>Showing 0 entries</span>                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalRows v-model="currentPage" :per-page=perPage :limit=limit @change="changePage">
                    </b-pagination>
                  </div>
                </div>
                <div>
                  <br/>
                  <br/>
                  <br/>
                  <span><b>Note: </b> Only rides using the Will-call SMS will appear in this table</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'
  import Multiselect from 'vue-multiselect'

  export default {
    metaInfo: {
      title: 'Wingz Support | Will Call Rides',
    },
    name: "WillCallRides",
    data () {
      return {
        title: 'Will Call Rides',
        current_ride_status: [{"name":"accepted","value":7},{"name":"en-route","value":10}],
        current_rider_email: null,
        current_rider_name_first: null,
        current_rider_name_last: null,
        current_driver_email: null,
        current_driver_name_first: null,
        current_driver_name_last: null,
        current_ride_pickup: null,
        current_ride_dropoff: null,
        selected_time_range: 24,
        min_date: null,
        max_date: null,
        page_sizes: [20, 50, 100],
        markets: null,
        data: {
          rides: [],
          filteredRides: [],
          sortedRides: [],
          filters: {
            status: [
              {"name":"unassigned","value":15},
              {"name":"accepted","value":7},
              {"name":"en-route","value":10},
              {"name":"picked-up","value":11},
              {"name":"dropped-off","value":12},
              {"name":"distributing_linear","value":16},
              {"name":"distributing_logarithmic","value":17},
              {"name":"expired","value":18},
              {"name":"canceled","value":23},
              {"name":"canceled_by_rider","value":2},
              {"name":"canceled_by_support","value":3},
              {"name":"rider_no_show","value":8},
              {"name":"driver_no_show","value":9},
              {"name":"paid_denied","value":24}
          ]          
          },
          resultColumns: ["Leg ID", "Trip ID", "Ride Status" ,"Driver", "Rider", "SMS Sent","SMS Confirmed", "From", "To"],
          waiting_statuses: ['unassigned','booked','accepted','en_route','distributing_linear','distributing_logarithmic'],
          sortDirection: 0,
        },
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 10,
        errors: null
      }
    },
    components: {
      Loading,
      Multiselect
    },
    methods: {
      currentSearch: function (page) {
        this.isLoading = true


        var date_filter = null
        if (this.selected_time_range != 'All') {
          date_filter = this.moment.utc().add(-1 * this.selected_time_range, 'hours').format()
        }
        console.log(date_filter)


        this.$http
          .get(process.env.API_BASE_URL_CS + 'willcall-rides/?'
            + (this.current_ride_status == null ? '' : '&ride__id_type_ride_status__in=' + this.current_ride_status.map(function(i) { return i.value}).join(','))
            // + (this.selected_market == "All" ? '' : '&id_market=' + this.selected_market.id_market)
            + (date_filter ? '&created_at__gte=' + date_filter : '')
            // + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            + '&ordering=-confirmed_at'
            + '&page=' + (page ? page : this.currentPage)
            + '&page_size=' + (this.perPage)
          )
          .then(response => {
            this.data.rides = response.data.results
            this.data.filteredRides = this.data.rides.slice(0)
            this.data.sortedRides = this.data.rides.slice(0)

            if (response.data && response.data.count) {
              this.totalRows = response.data.count
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      currentButtonSearch(page) {        
        this.resetPager()
        this.currentSearch(page)
      },
      getMarkets: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'markets/')
          .then(response => {
            this.markets = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
      },

      changePage: function (page) {
        this.currentSearch(page)
      },
      checkPageSize: function(event) {
        this.currentSearch()
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      },
      clearDate(date) {
        if (date == 'min_date') {
          this.min_date = null
        }
        if (date == 'max_date') {
          this.max_date = null
        }
      },
    },
    mounted: function () {
      this.currentSearch()
      this.getMarkets()


      // $(".select2").select2();

    },
    created () {
      // document.title = "Wingz Support | Current Rides";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
 .table td {
    vertical-align: middle;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
  .table-responsive {
    overflow: hidden;
  }
  .multiselect {
    min-height: unset;
  }
  .multiselect >>> .multiselect__content-wrapper {
    max-height: unset !important;
  }
  .multiselect >>> .multiselect__tags {
    border: none;
    border-bottom: 1.25px solid #e9edf2;
    border-radius: 0px;
    padding: 1px 40px 0 8px;
    min-height: unset;    
  }
  .multiselect >>> .multiselect__select {
    height: 18px;
    right: 1px;
    top: 1px;
    padding: 0px 8px;
  }
  .multiselect >>> .multiselect__select:before {
		content: "\F140";
    font: normal normal normal 24px/1 "Material Design Icons";
    font-size: 18px;
    border: none;
    top: 0%;    
    color: #666666;
    font-weight: 100;    
  }
  .multiselect >>> .multiselect__tag {
    margin-bottom: 0px;
  }
  .multiselect >>> .multiselect__placeholder {
    margin-bottom: 5px;
    color: #67757c;
    font-size: .875rem;
    font-weight: 400;    
  }
</style>



// WEBPACK FOOTER //
// src/components/WillCallRides.vue